// src/pages/income/_shared/IncomeDraftPreviewWindow.jsx
// ✅ 지출 쪽 _shared/ExpenseDraftPreviewWindow.jsx와 동일한 패턴 — 작성 페이지가
// sessionStorage(초기값)+BroadcastChannel(갱신)로 넘긴 현재 폼 상태를 그대로
// IncomeProposalPreview로 렌더한다. onSave를 넘기지 않아 저장 버튼은 뜨지 않는다
// (저장은 항상 원본 탭에서만).
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import IncomeProposalPreview from "../../../components/preview/income/IncomeProposalPreview";

export default function IncomeDraftPreviewWindow({ config }) {
  const { previewStorageKey, previewChannelName } = config;
  const [searchParams] = useSearchParams();
  const autoDownload = searchParams.get("action") === "download";
  const autoPrint = searchParams.get("action") === "print";

  const readStoredData = () => {
    try {
      const raw = sessionStorage.getItem(previewStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const [data, setData] = useState(readStoredData);

  useEffect(() => {
    if (!("BroadcastChannel" in window)) return;
    const channel = new BroadcastChannel(previewChannelName);
    channel.onmessage = (e) => {
      if (e.data?.type === "update") setData(e.data.payload);
      if (e.data?.type === "clear") setData(null);
    };
    return () => channel.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewChannelName]);

  // ✅ "PDF 다운로드" 액션 — IncomeProposalPreview 자체의 기존 다운로드 버튼(.download-button,
  // html2pdf 기반)을 프로그램적으로 클릭. 컴포넌트를 전혀 수정하지 않고 재사용.
  useEffect(() => {
    if (!autoDownload || !data) return;
    const timer = setTimeout(() => {
      document.querySelector(".download-button")?.click();
    }, 600);
    return () => clearTimeout(timer);
  }, [autoDownload, data]);

  useEffect(() => {
    if (!autoPrint || !data) return;
    const timer = setTimeout(() => window.print(), 600);
    return () => clearTimeout(timer);
  }, [autoPrint, data]);

  useEffect(() => {
    document.title = "기안 문서 미리보기";
  }, []);

  if (!data) {
    return (
      <div style={{ padding: 24, fontSize: 14, color: "#666" }}>
        작성 중인 문서가 없습니다.
      </div>
    );
  }

  return (
    <div className="preview-window-page" style={{ padding: 16 }}>
      <style>{`
        @media print {
          .preview-window-page { padding: 0 !important; }
        }
      `}</style>
      <IncomeProposalPreview
        formData={data.formData}
        approvalLine={data.approvalLine}
      />
    </div>
  );
}
